"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
require("./styles/profile.scss");
var controllers_1 = require("./controllers");
var services_1 = require("./services");
var routes_1 = __importDefault(require("./config/routes"));
/**
 * @ngdoc module
 * @module rinca.apps.discount
 * @name rinca.apps.discount
 * @packageName rinca.apps
 * @description A module that includes the discount component.
 */
angular.module('rinca.apps.profile', ['ui.router'])
    .controller('ProfileBasicController', controllers_1.ProfileBasicController)
    .controller('ProfileAddressController', controllers_1.ProfileAddressController)
    .controller('ProfileAccessController', controllers_1.ProfileAccessController)
    .service('_profile', services_1.ProfileService)
    .config(routes_1.default);



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/profile/index.js
// module id = 430
// module chunks = 0